import {
  VALIDATION_RULE_GROUP_CONTACTS,
  VALIDATION_RULE_GROUP_CSSF_DOCUMENTS,
  VALIDATION_RULE_GROUP_DOCUMENTS,
  VALIDATION_RULE_GROUP_ENTITIES,
  VALIDATION_RULE_GROUP_ENTRY_FORM_GENERAL,
  VALIDATION_RULE_GROUP_FINAL_TERMS,
  VALIDATION_RULE_GROUP_LEGISLATION,
  VALIDATION_RULE_GROUP_LIST_OF_SECURITIES,
  VALIDATION_RULE_GROUP_NOTIFICATION,
} from './constants';

type EntitiesMap = {
  [key: string]: any;
};

interface ValidationRuleConfig {
  [rule: string]: {
    route: (entities: EntitiesMap) => string;
    groupBy?: string;
    filterAlert?: (rule: any, entityId?: number) => boolean;
    zone?: {
      [key: string]: string;
    };
  };
}

const validationRuleGroupMap: ValidationRuleConfig = {
  [VALIDATION_RULE_GROUP_ENTRY_FORM_GENERAL]: {
    route: () => 'general',
  },
  [VALIDATION_RULE_GROUP_ENTITIES]: {
    route: () => 'entities',
  },
  [VALIDATION_RULE_GROUP_CSSF_DOCUMENTS]: {
    route: () => 'cssf-documents',
  },
  [VALIDATION_RULE_GROUP_LIST_OF_SECURITIES]: {
    route: () => 'securities',
  },
  [VALIDATION_RULE_GROUP_LEGISLATION]: {
    route: () => 'legislation',
  },
  [VALIDATION_RULE_GROUP_CONTACTS]: {
    route: () => 'entitled-persons',
  },
  [VALIDATION_RULE_GROUP_DOCUMENTS]: {
    route: () => 'documents',
  },
  [VALIDATION_RULE_GROUP_NOTIFICATION]: {
    route: () => 'notifications',
  },
  [VALIDATION_RULE_GROUP_FINAL_TERMS]: {
    route: () => 'final-terms',
  },
};

export default validationRuleGroupMap;
